import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import Gallery from '../Gallery'
import TireHeader from '../TireHeader'
import TireCostForm from '../TireCostForm'
import TirePromotion from '../TirePromotion'
import TabsTireDetails from '../TabsTireDetails'
import { Column } from '../Common.styles'
import 'components/Main/globalStyles'
import { PRODUCT_DETAILS_SCHEMA_ID } from 'constant'
import SyndigoContent from '../SyndigoContent'

const BOTSkuDetailComponent = ({
  skuDetails,
  skuDetails: {
    brandName = '',
    name = '',
    skuId = '',
    mainImageUrl = ''
  } = {},
  initialValues,
  badgeTitle,
  specificationsToDisplay,
  vehicleName,
  offers = undefined,
  skuDetailDescription = undefined,
  content,
  showCitiBanner,
  isEvItem,
  itemEVType,
  schemaUrl,
  aggregateRating = undefined,
  review = undefined
}) =>
  <div>
    <Helmet>
      <script nonce={ window.BOT_NONCE } type="application/ld+json" id={ PRODUCT_DETAILS_SCHEMA_ID }>
        {
          JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            brand: brandName,
            name,
            url: schemaUrl,
            description: skuDetailDescription,
            sku: skuId,
            gtin12: '', // In future sprints add UPC value to the schema when we can receive it from the BE.
            image: mainImageUrl,
            offers,
            aggregateRating,
            review
          })
        }
      </script>
    </Helmet>
    <Column responsive padding_desktop="0 10px 0 50px">
      <Media.Mobile>
        <TireHeader
          { ...skuDetails }
          vehicleName={ vehicleName }
          itemEVType={ itemEVType }
          isEvItem={ isEvItem } />
      </Media.Mobile>
      <Gallery { ...skuDetails } badgeTitle={ badgeTitle } />
    </Column>
    <Column responsive padding_desktop="0 50px 0 10px">
      <Media.Desktop>
        <TireHeader
          { ...skuDetails }
          vehicleName={ vehicleName }
          itemEVType={ itemEVType }
          isEvItem={ isEvItem } />
      </Media.Desktop>
      <TireCostForm initialValues={ initialValues } { ...skuDetails } />
      <TirePromotion content={ content } showCitiBanner={ showCitiBanner } { ...skuDetails } />
    </Column>
    <TabsTireDetails specificationsToDisplay={ specificationsToDisplay } { ...skuDetails } />
    <SyndigoContent productId={ skuId } />
  </div>

BOTSkuDetailComponent.propTypes = {
  aggregateRating: PropTypes.shape({}),
  badgeTitle: PropTypes.string,
  benefitsDescription: PropTypes.string,
  content: PropTypes.string,
  handlePromotionClick: PropTypes.func,
  initialValues: PropTypes.shape({
    tireFrontQuantity: PropTypes.number,
    tireRearQuantity: PropTypes.number
  }),
  isEvItem: PropTypes.bool,
  itemEVType: PropTypes.string,
  offers: PropTypes.shape({}),
  review: PropTypes.arrayOf(),
  schemaUrl: PropTypes.string,
  showCitiBanner: PropTypes.bool,
  skuDetailDescription: PropTypes.string,
  skuDetails: PropTypes.shape(),
  specificationsToDisplay: PropTypes.string,
  vehicleName: PropTypes.string
}

export default BOTSkuDetailComponent
